module.exports = __webpack_public_path__ + "static/media/smile.057d1fc5.svg";